module.exports = __webpack_public_path__ + "assets/blue-down-arrow.d639ee7292e935ba2af718deabce6c34.svg";